<template>
  <div>
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <header-banner title="よくあるご質問" />
    <question-and-answer
      :number="1"
      :question="'注文してから発送までどれくらいの時間がかかりますか？'"
      :answer="
        `ネットでのご注文は年中無休 24 時間受け付けております。
        ご注文を受けてから 1 ～ 3 営業日（休業日を除く）で、メーカーから商品を直接発送いたします。
        ※但し、在庫の有る商品に限ります。`
      "
    />
    <question-and-answer
      :number="2"
      :question="'商品代金以外に送料、代引き手数料はかかりますか？'"
      :answer="`送料（国内に限り）、代引き手数料は当社で負担いたします。`"
    />
    <question-and-answer
      :number="3"
      :question="'商品の保証期間はいつまでですか？'"
      :answer="
        `販売後 1 年間の無償保証修理を行っております。（故意によるものは除きます）
        ※エコチャイムのみ販売後 3 年間の無償保証修理を行っております。
        また、それ以降でも有償となりますが、いつでも迅速に修理させていただきます。
        また、保証期間中はもちろん保証期間外でも修理期間中は貸出機をご提供するなどのサービスを行っています。`
      "
    />
    <question-and-answer
      :number="4"
      :question="'商品を修理に出した際、代替え品等の対応はありますか？'"
      :answer="
        `貸出機をお届けいたします。修理完了後に交換させていただきますのでご安心ください。`
      "
    />
    <question-and-answer
      :number="5"
      :question="'どの商品が良いのか自分では選べません'"
      :answer="
        `お悩みの場合は、お問合せ下さい。
        担当者がお客様のご要望をお聞きして、最適な商品をご提案させていただきます。`
      "
    />
  </div>
</template>

<script>
import HeaderBanner from '@/components/modules/HeaderBanner'
import QuestionAndAnswer from '@/components/modules/QuestionAndAnswer'
import Breadcrumb from '@/components/modules/Breadcrumb'

export default {
  components: {
    HeaderBanner,
    QuestionAndAnswer,
    Breadcrumb,
  },
  title: 'よくあるご質問｜B-Call（ビーコール）',
  computed: {
    breadcrumbs: function() {
      return {
        data: [
          {
            name: '呼び出しベルのB-Call',
            path: 'https://b-call.jp/',
          },
          {
            name: 'よくあるご質問',
            path: 'https://b-call.jp/faq',
          },
        ],
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Faq.vue